import React from 'react';
import GeckoErrorsAlert from 'components/GeckoErrorsAlert';

const NewIntegrations = ({ syncs, errors }) => {
  const secondaryIdsAndSyncErrors = syncs
    .map((sync) => {
      const secondaryId = sync.secondaryId;
      const error = sync.error;
      if (!secondaryId && !error) {
        return null;
      }
      return {
        secondaryId: secondaryId ? secondaryId.split(':') : null,
        error: error,
        connectionName: sync.connectionName,
        primaryModule: sync.primaryModule,
      };
    })
    .filter(Boolean);

  if (
    secondaryIdsAndSyncErrors.length === 0 && errors.length === 0
  ) {
    return null;
  }

  return (
    <div>
        <GeckoErrorsAlert errors={errors}/>
        {secondaryIdsAndSyncErrors.map((secondaryIdAndError, i) => {
            const prettyPrimaryModule = secondaryIdAndError.primaryModule[0].toUpperCase() + secondaryIdAndError.primaryModule.slice(1);

            const [integrationType, integrationId, moduleName, entityId] =
                secondaryIdAndError.secondaryId
                    ? secondaryIdAndError.secondaryId
                    : [];
            const idString = integrationType
                ?
                `${prettyPrimaryModule} synced with ${moduleName[0].toUpperCase()}${moduleName.slice(1)} ID ${entityId}`
                : '';
            const connectionName = secondaryIdAndError.connectionName;
            const syncError = secondaryIdAndError.error;
            const syncErrorString = `${prettyPrimaryModule} failed to sync; ${syncError}`

            return (
                <div className="integration" key={i}>
                    <span className="integration_name">{connectionName}:</span>{' '}
                    <div>{syncError ? syncErrorString : idString}</div>
                </div>
            );
        })}
    </div>
  );
};

export default NewIntegrations;
